import { MediumHeader } from '@narvar/nth-bit-header';
import { RetailerTheme } from '@narvar/nth-hook-loma';
import { useTheme, withThemeProvider } from '@narvar/nth-hook-theme';
import React, { CSSProperties, ReactElement } from 'react';
import RescheduleLink from './RescheduleLInk';
import { useTranslator } from '../utils/translator';

interface ScheduledDeliveryInstructionsProps {
  featureName?: string;
  additionalInstructions?: string | ReactElement;
  rescheduleEnabled: boolean;
  onRescheduleClick: () => void;
}

const ScheduledDeliveryInstructions = ({
  featureName,
  additionalInstructions,
  rescheduleEnabled,
  onRescheduleClick,
}: ScheduledDeliveryInstructionsProps) => {
  const { bodytextDefaultNone: bodyText } = useTheme() as {
    [key in keyof RetailerTheme]: CSSProperties;
  };
  const { t } = useTranslator();

  const scheduleDeliveryInstructionsHeader = t('Delivery Instructions');
  const scheduleDeliveryInstructionsContent = t(
    'Please keep path cleared and be home in the scheduled time window. Need to make changes to your delivery date and time?',
  );

  const handleClick = () => {
    onRescheduleClick();
  };

  return (
    <>
      <MediumHeader as="h3">{scheduleDeliveryInstructionsHeader}</MediumHeader>
      <p style={{ ...bodyText }}>{scheduleDeliveryInstructionsContent}</p>
      {additionalInstructions && (
        <p style={{ ...bodyText }}>{additionalInstructions}</p>
      )}
      {rescheduleEnabled && (
        <RescheduleLink featureName={featureName} onClick={handleClick} />
      )}
    </>
  );
};

export default withThemeProvider(ScheduledDeliveryInstructions, {
  themeTokens: ['bodytextDefaultNone'],
});
